import { render, staticRenderFns } from "./assessment-details.vue?vue&type=template&id=0f74567e&scoped=true&"
import script from "./assessment-details.vue?vue&type=script&lang=ts&"
export * from "./assessment-details.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-details.vue?vue&type=style&index=0&id=0f74567e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f74567e",
  null
  
)

export default component.exports